// JustMakeLegacy — scripts globales
if (!window.__jmlScriptsLoaded) {
  window.__jmlScriptsLoaded = true;
  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initComparador();
    initContadores();
    initMarquesina();
    initInclinacion();
    initGaleriaProducto();
    initVariantesProducto();
  });
}

function initGaleriaProducto() {
  var grupos = document.querySelectorAll('[data-jml-galeria-thumbs]');
  grupos.forEach(function (grupo) {
    var principal = grupo.parentElement.querySelector('[data-jml-galeria-principal] img');
    if (!principal) return;
    grupo.querySelectorAll('[data-jml-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        principal.src = thumb.getAttribute('data-full');
        grupo.querySelectorAll('[data-jml-thumb]').forEach(function (t) { t.classList.remove('is-activa'); });
        thumb.classList.add('is-activa');
      });
    });
  });
}

function initVariantesProducto() {
  document.querySelectorAll('product-form').forEach(function (formEl) {
    var script = formEl.querySelector('[data-jml-variantes]');
    var opciones = formEl.querySelector('[data-jml-opciones]');
    if (!script) return;

    var variantes;
    try { variantes = JSON.parse(script.textContent); } catch (e) { return; }
    if (!opciones) return;

    var selects = Array.from(opciones.querySelectorAll('[data-jml-opcion-indice]'))
      .sort(function (a, b) { return Number(a.getAttribute('data-jml-opcion-indice')) - Number(b.getAttribute('data-jml-opcion-indice')); });

    var idInput = formEl.querySelector('[data-jml-variant-input]');
    var boton = formEl.querySelector('[data-jml-boton-comprar]');
    var precioActual = formEl.closest('.jml-prod__compra').querySelector('.jml-prod__precio-actual');
    var precioAntes = formEl.closest('.jml-prod__compra').querySelector('.jml-prod__precio-antes');

    function variantePorSeleccion() {
      var seleccion = selects.map(function (s) { return s.value; });
      return variantes.find(function (v) {
        return v.options.length === seleccion.length && v.options.every(function (opt, i) { return opt === seleccion[i]; });
      });
    }

    function aplicarVariante(v) {
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (precioActual) precioActual.textContent = v.precio;
      if (precioAntes) {
        if (v.comparar) { precioAntes.textContent = v.comparar; precioAntes.style.display = ''; }
        else { precioAntes.style.display = 'none'; }
      }
      if (boton) {
        var texto = boton.querySelector('span');
        if (v.available) {
          boton.removeAttribute('aria-disabled');
          boton.removeAttribute('disabled');
          if (texto) texto.textContent = boton.getAttribute('data-texto-disponible') || texto.textContent;
        } else {
          boton.setAttribute('aria-disabled', 'true');
          boton.setAttribute('disabled', 'disabled');
          if (texto) texto.textContent = boton.getAttribute('data-texto-agotado') || texto.textContent;
        }
      }
    }

    selects.forEach(function (select) {
      select.addEventListener('change', function () {
        aplicarVariante(variantePorSeleccion());
      });
    });
  });
}

function initReveal() {
  var els = document.querySelectorAll('.jml-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('jml-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('jml-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el) { observer.observe(el); });
}

function initComparador() {
  var wraps = document.querySelectorAll('[data-jml-comparador]');
  if (!wraps.length) return;
  wraps.forEach(function (wrap) {
    var handle = wrap.querySelector('[data-jml-asa]');
    var afterEl = wrap.querySelector('[data-jml-despues]');
    var range = wrap.querySelector('[data-jml-rango]');
    if (!handle || !afterEl) return;

    function setPos(pct) {
      pct = Math.max(0, Math.min(100, pct));
      afterEl.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      handle.style.left = pct + '%';
      if (range) range.value = pct;
    }

    setPos(50);

    var dragging = false;
    function pctFromEvent(evt) {
      var rect = wrap.getBoundingClientRect();
      var x = (evt.touches ? evt.touches[0].clientX : evt.clientX) - rect.left;
      return (x / rect.width) * 100;
    }
    handle.addEventListener('pointerdown', function (e) {
      dragging = true;
      handle.setPointerCapture(e.pointerId);
    });
    wrap.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      setPos(pctFromEvent(e));
    });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (evt) {
      handle.addEventListener(evt, function () { dragging = false; });
    });
    wrap.addEventListener('click', function (e) {
      if (e.target === handle) return;
      setPos(pctFromEvent(e));
    });
    if (range) {
      range.addEventListener('input', function () { setPos(Number(range.value)); });
    }
    handle.addEventListener('keydown', function (e) {
      var current = parseFloat(handle.style.left) || 50;
      if (e.key === 'ArrowLeft') setPos(current - 5);
      if (e.key === 'ArrowRight') setPos(current + 5);
    });
  });
}

function initContadores() {
  var nums = document.querySelectorAll('[data-jml-contador]');
  if (!nums.length) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function animate(el) {
    var target = parseFloat(el.getAttribute('data-jml-contador')) || 0;
    var suffix = el.getAttribute('data-jml-sufijo') || '';
    var decimals = el.getAttribute('data-jml-decimales') ? parseInt(el.getAttribute('data-jml-decimales'), 10) : 0;
    if (reduced) {
      el.textContent = target.toFixed(decimals) + suffix;
      return;
    }
    var duration = 1600;
    var start = null;
    function step(ts) {
      if (!start) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var value = target * eased;
      el.textContent = value.toFixed(decimals) + suffix;
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        animate(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.4 });
  nums.forEach(function (el) { observer.observe(el); });
}

function initMarquesina() {
  var tracks = document.querySelectorAll('[data-jml-marquesina]');
  tracks.forEach(function (track) {
    if (track.dataset.jmlDuplicado) return;
    track.innerHTML += track.innerHTML;
    track.dataset.jmlDuplicado = 'true';
  });
}

function initInclinacion() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.matchMedia('(pointer: coarse)').matches) return;
  var cards = document.querySelectorAll('[data-jml-tilt]');
  cards.forEach(function (card) {
    card.addEventListener('mousemove', function (e) {
      var rect = card.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width - 0.5;
      var y = (e.clientY - rect.top) / rect.height - 0.5;
      card.style.transform = 'perspective(800px) rotateY(' + (x * 6) + 'deg) rotateX(' + (y * -6) + 'deg) translateY(-4px)';
    });
    card.addEventListener('mouseleave', function () {
      card.style.transform = '';
    });
  });
}
